export class StorageService {
  constructor(prefix = 'tiagpc') {
    this.prefix = prefix;
  }


  _getKey(key) {
    return `${this.prefix}_${key}`;
  }

  set(key, data) {
    try {
      const fullKey = this._getKey(key);
      const serialized = JSON.stringify(data);
      localStorage.setItem(fullKey, serialized);
      return true;
    } catch (error) {
      console.warn(`[StorageService] Error guardando ${key}:`, error);
      return false;
    }
  }


  get(key) {
    try {
      const fullKey = this._getKey(key);
      const serialized = localStorage.getItem(fullKey);

      if (serialized === null) {
        return null;
      }

      return JSON.parse(serialized);
    } catch (error) {
      console.warn(`[StorageService] Error leyendo ${key}:`, error);
      this.remove(key);
      return null;
    }
  }


  remove(key) {
    try {
      const fullKey = this._getKey(key);
      localStorage.removeItem(fullKey);
      return true;
    } catch (error) {
      console.warn(`[StorageService] Error eliminando ${key}:`, error);
      return false;
    }
  }


  has(key) {
    const fullKey = this._getKey(key);
    return localStorage.getItem(fullKey) !== null;
  }


  clear() {
    try {
      const keys = Object.keys(localStorage);
      const prefixedKeys = keys.filter(key => key.startsWith(`${this.prefix}_`));

      prefixedKeys.forEach(key => {
        localStorage.removeItem(key);
      });

      return true;
    } catch (error) {
      console.warn('[StorageService] Error limpiando datos:', error);
      return false;
    }
  }


  setWithTimestamp(key, data) {
    return this.set(key, {
      data,
      timestamp: Date.now()
    });
  }


  getWithExpiry(key, maxAge) {
    const stored = this.get(key);

    if (!stored || !stored.timestamp) {
      return null;
    }

    const age = Date.now() - stored.timestamp;

    if (age > maxAge) {
      this.remove(key);
      return null;
    }

    return stored.data;
  }
}
